import type {
  IOnboardingInitiateClaimProfileBody,
  IOnboardingInitiateClaimProfileRequest,
  IOnboardingInitiateClaimProfileResponse,
} from '@/app-package';

import axios from 'axios';

const initiateClaimProfile = async (
  body: IOnboardingInitiateClaimProfileBody,
) => {
  const url = `/onboarding/claim`;

  const config: IOnboardingInitiateClaimProfileRequest = {
    url,
    method: 'post',
    data: body,
  };

  const { data } =
    await axios.request<IOnboardingInitiateClaimProfileResponse>(config);

  return data;
};

export default initiateClaimProfile;
